import styled from 'components/_UI/designSystem';
import { Flexbox } from 'components/spaceKit';
export const StyledInput = styled(Flexbox)`
    width: 54px;
    min-width: 54px;
    max-width: 54px;
    > div {
        height: 40px;
    }
`;
